const WORDS = ["MUSIC", "BOOKINGS", "PRODUCTS", "VIDEO", "NEWSLETTERS", "EVENTS", "LINKS"];

const Row = ({ reverse = false }) => (
  <div className={`marquee-track ${reverse ? "reverse" : ""}`}>
    {[...WORDS, ...WORDS].map((w, i) => (
      <span key={i} className="mx-6 flex items-center gap-6">
        <span className="font-display text-5xl font-semibold tracking-tight text-stroke md:text-7xl">
          {w}
        </span>
        <span className="h-2 w-2 rounded-full bg-lime" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section
    data-testid="marquee"
    className="overflow-hidden border-y border-line bg-surfaceAlt py-10"
    aria-hidden="true"
  >
    <Row />
  </section>
);
